/*
* 车辆信息管理组件
*/

import { Component, useState } from 'react';
import $ from 'jquery';
import CNF from '../../incs/Config';
import {
    Row,
    Col,
    message,
    Table,
    Input,
    Select,
    Button,
    Space,
    Statistic,
    Tag,
    theme,
} from 'antd';
import {
    PlusOutlined,
    ExportOutlined,
} from '@ant-design/icons';
import {
    UjoinParams,
    AddRequestHeaders,
    DateFormat,
    isGTscreenWidth,
    ShowIPModal,
    GetDropdownActionName,
    rootReactDom,
} from '../../incs/FunHelper.js';
import ExportJsonExcel from 'js-export-excel';

import CarEntity from './CarEntity';
import CarMileageEntity from './CarMileageEntity';
import CarInfo from './CarInfo.js';

const Option = Select.Option;
const MODULENAME = CNF.navItems[1].submenu[0].name.replace('管理', '');
const MODULENAME_PTN = CNF.navItems[1].submenu[0].ptn;

const Lists = (props) => {
    const [open, setOpen] = useState(false);
    const [record, setRecord] = useState(null);

    const {
        token: {
            colorPrimary,           // 主色
            colorPrimaryBg,         // 主色浅色背景色
        },
    } = theme.useToken();

    const updateMileage = (open, record) => {
        setOpen(open);
        setRecord(record);
    }

    const update = (record) => { this.props.setOpen(true, record); }

    /**
     * 操作选项
     * @param {*} action 
     * @param {*} record 
     */
    const operation = (action, record) => {
        let uri = 'cars/' + record.key;
        switch (action) {
            case '里程':
                this.updateMileage(true, record);
                break;
            case CNF.actionName.UPDATE:
                update(record);
                break;
            case CNF.actionName.DISABLE:
            case CNF.actionName.ACTIVE:
            case CNF.actionName.DELETE:
                ShowIPModal(record.key, record.rolename, action, MODULENAME, this.props.isRefresh, uri);
                break
            default:
                break;
        }
    }

    /**
     * 显示车辆弹框信息
     * @param {*} record 
     */
    const showCarInfo = (record) => {
        rootReactDom && rootReactDom.render(
            <CarInfo
                colorPrimaryBg={colorPrimaryBg}
                preGroup={props.preGroup}
                open={true}
                record={record}
            />);
    }

    const columns = [
        { title: '', dataIndex: '', key: 'key', fixed: 'left', width: CNF.searchMarginLeft * 4, },
        {
            title: '车牌号码', key: 'license_number', fixed: 'left', width: 120,
            render: (record) => <Button
                color='primary'
                variant='link'
                style={{ padding: 0, margin: 0, height: 22 }}
                onClick={() => { showCarInfo(record) }}
            >{record.license_number}</Button>
        },
        { title: '车辆名称', dataIndex: 'name', key: 'name', },
        { title: '车辆型号', dataIndex: 'model', key: 'model', },
        { title: '驾驶人', dataIndex: 'driver_displayname', key: 'driver_displayname', },
        { title: '用途', dataIndex: 'uses', key: 'uses', ellipsis: true, hidden: isGTscreenWidth ? false : true, },
        { title: '购买时间', dataIndex: 'purchase_time', key: 'purchase_time', },
        {
            title: '当前里程(km)', key: 'current_mileage',
            render: (record) => <Tag color={colorPrimaryBg} style={{ width: '50%' }}><Statistic valueStyle={{ fontSize: CNF.fontSize - 2, color: colorPrimary }} value={record.current_mileage} /></Tag>
        },
        { title: '创建时间', dataIndex: 'create_time', key: 'create_time', width: CNF.tableCreateTimeColumnWidth, },
        { title: '创建者', dataIndex: 'create_displayname', key: 'create_displayname', width: CNF.tableCreateDisplayeColumnWidth, },
        { title: '状态', key: 'status', fixed: 'right', dataIndex: 'status', width: CNF.tableStatusColumnWidth, },
        {
            title: '', key: 'operation', fixed: 'right', width: CNF.tableOperationColumnWidth, hidden: (
                props.btnLists.indexOf(MODULENAME_PTN + '_update') > 0 ||
                props.btnLists.indexOf(MODULENAME_PTN + '_disable') > 0 ||
                props.btnLists.indexOf(MODULENAME_PTN + '_active') > 0 ||
                props.btnLists.indexOf(MODULENAME_PTN + '_delete') >= 0
            ) ? false : true,
            render: (record) => GetDropdownActionName(props.btnLists, MODULENAME_PTN, record, operation)
        }
    ];
    return (
        <>
            <Table
                columns={columns}
                size='middle'
                dataSource={props.dataLists}
                pagination={{
                    showSizeChanger: false,
                    // pageSizeOptions: ['10', '15', '20', '30','40','50'],
                    showQuickJumper: false,
                    showTotal: () => `共${props.pageCount > 10000 ? (props.pageCount / 10000).toFixed(CNF.DPL) + '万' : props.pageCount}条`,
                    current: props.currentIndex,
                    total: props.pageCount,
                    onShowSizeChange: (current, pageSize) => props.changePageSize(pageSize, current),
                    onChange: (current) => props.changeIndex(current),
                }}
            />
            <CarMileageEntity
                isRefresh={props.isRefresh}
                open={open}
                record={record}
                updateMileage={updateMileage}
            />
        </>
    );
}

class CPT extends Component {
    constructor(props) {
        super(props);
        this.state = {
            record: null,
            open: false,
            init: 0,
            isRefresh: 0,
            currentIndex: 1,
            pageCount: 0,
            dataLists: [],
            licenseNumber: '',
            driverDisplayname: '',
            status: CNF.status[0].value,
        }
    }

    isRefresh = () => { this.setState({ isRefresh: this.state.isRefresh === 1 ? 0 : 1 }); }
    search = () => { this.setState({ currentIndex: 1 }); this.isRefresh(); }
    changeLicenseNumber = (e) => { this.setState({ licenseNumber: e.target.value }); this.search(); }
    changeDriverDisplayname = (e) => { this.setState({ driverDisplayname: e.target.value }); this.search(); }
    changeStatus = (value) => { this.setState({ status: value === undefined ? '' : value }); this.search(); }
    changeIndex = (index) => { this.setState({ currentIndex: index }); this.isRefresh(); }

    setOpen = (value, record) => { this.setState({ open: value, record: record }); }
    create = () => { this.setOpen(true, null); }

    /**
     * 获取列表
     */
    getLists() {
        const _this = this;
        const params = {
            'license_number': this.state.licenseNumber,
            'driver_displayname': this.state.driverDisplayname,
            'status': this.state.status,
            'page_size': CNF.pageSize,
            'current_index': this.state.currentIndex
        };
        $.ajax({
            url: `${CNF.api}cars${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET'
        }).done(function (data) {
            if (data.res === 0) {
                if (data.dat.length > 0) {
                    _this.setState({
                        dataLists: data.dat,
                        pageCount: data.cnt
                    });
                } else {
                    _this.setState({
                        dataLists: [],
                        pageCount: 0
                    });
                }
            } else {
                message.error(data.msg, CNF.messageDuration);
            }
        }).fail(function (data) {
            message.error(data.responseJSON.detail, CNF.messageDuration);
        });
    }

    /***
    * 导出 Excel
    */
    exportAsExcel = (data) => {
        var date = new Date();
        let option = {};  //    option代表的就是excel文件
        option.fileName = '车辆信息明细-' + DateFormat('YYYY-mm-dd', date);  //   excel文件名称
        option.datas = [
            {
                sheetData: data,  //   excel文件中的数据源
                sheetName: '车辆信息明细',  //  excel文件中sheet页名称
                sheetHeader: [
                    '车牌号码',
                    '车辆名称',
                    '车辆型号',
                    '驾驶人',
                    '用途',
                    '购买时间',
                    '当前里程',
                    '状态',
                    '备注'],  //  excel文件中每列的表头名称
            }
        ]
        let toExcel = new ExportJsonExcel(option);  //生成excel文件
        toExcel.saveExcel();  //下载excel文件
    }

    /***
     * 获取导出车辆信息明细
     */
    export() {
        const _this = this;
        const params = {
            'license_number': this.state.licenseNumber,
            'driver_displayname': this.state.driverDisplayname,
            'status': this.state.status,
            'page_size': 65535,
            'current_index': 1
        }
        $.ajax({
            url: `${CNF.api}cars${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    if (data.dat.length > 0) {
                        //  删除非必须字段
                        var d = [];
                        for (let i = 0; i < data.dat.length; i++) {
                            var item = data.dat[i]
                            delete item['key'];
                            delete item['driver_username']
                            delete item['create_username']
                            delete item['create_displayname']
                            delete item['create_time']
                            delete item['update_time']
                            d.push(item);
                        }
                        _this.exportAsExcel(d);
                    } else {
                        _this.exportAsExcel([]);
                    }
                } else {
                    message.error(data.msg, CNF.messageDuration);
                }
            }
        })
    }

    componentDidUpdate() {
        if (this.state.init !== this.state.isRefresh) {
            this.getLists();
            this.setState({
                init: this.state.isRefresh
            });
        }
    }

    componentDidMount() {
        this.getLists();
    }

    render() {
        return (
            <>
                <Row style={{ paddingTop: CNF.searchMarginLeft * 4, paddingBottom: CNF.searchMarginLeft * 4, paddingLeft: CNF.searchMarginLeft * 4 }}>
                    <Col span={isGTscreenWidth ? 2 : 3}>
                        <Input
                            onChange={this.changeLicenseNumber}
                            placeholder='车牌号码'
                            value={this.state.licenseNumber}
                        />
                    </Col>
                    <Col span={isGTscreenWidth ? 2 : 3} style={{ marginLeft: CNF.searchMarginLeft }}>
                        <Input
                            onChange={this.changeDriverDisplayname}
                            placeholder='驾驶人'
                            value={this.state.driverDisplayname}
                        />
                    </Col>
                    <Col span={2} style={{ marginLeft: CNF.searchMarginLeft }}>
                        <Select
                            allowClear
                            placeholder='状态'
                            style={{ width: '100%' }}
                            onChange={this.changeStatus}
                        >
                            {
                                CNF.status && CNF.status.map((item) => {
                                    return <Option key={item.value} value={item.value}>{item.key}</Option>
                                })
                            }
                        </Select>
                    </Col>
                    <Space size={CNF.searchMarginLeft} style={{ marginLeft: CNF.searchMarginLeft }}>
                        {
                            this.props.btnLists.indexOf(MODULENAME_PTN + '_create') >= 0 ? (
                                <Button
                                    title={CNF.actionName.CREATE + MODULENAME}
                                    color='primary'
                                    variant='solid'
                                    icon={<PlusOutlined />}
                                    onClick={() => {
                                        this.create();
                                    }}>
                                    {CNF.actionName.CREATE}
                                </Button>
                            ) : ''
                        }
                        {
                            this.props.btnLists.indexOf(MODULENAME_PTN + '_export') >= 0 ? (
                                <Button
                                    title={CNF.actionName.EXPORT + MODULENAME}
                                    color='primary'
                                    variant='solid'
                                    icon={<ExportOutlined />}
                                    onClick={() => {
                                        this.export();
                                    }}>
                                    {CNF.actionName.EXPORT}
                                </Button>
                            ) : ''
                        }
                    </Space>
                    <CarEntity
                        policy={this.props.policy}
                        open={this.state.open}
                        record={this.state.record}
                        setOpen={this.setOpen}
                        isRefresh={this.isRefresh}
                    />
                </Row>
                <Row>
                    <Col span={24}>
                        <Lists
                            btnLists={this.props.btnLists}
                            dataLists={this.state.dataLists}
                            currentIndex={this.state.currentIndex}
                            pageCount={this.state.pageCount}
                            changeIndex={this.changeIndex}
                            setOpen={this.setOpen}
                            isRefresh={this.isRefresh}
                        />
                    </Col>
                </Row>
                <div id='show-mileage-id'></div>
            </ >
        );
    }
}

export default CPT